(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceHeaderController', InvoiceHeaderController);

    InvoiceHeaderController.$inject = ['$state', 'InvoiceHeader', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InvoiceHeaderController($state, InvoiceHeader, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;

        loadAll();

        /* The search branch that used to sit here called InvoiceHeaderSearch - JHipster
           Elasticsearch scaffolding this application never had. Injecting it threw "Unknown
           provider", which killed the controller, so this page rendered NOTHING even when nobody
           was searching. There is no search endpoint for this entity, so the control has been
           removed rather than left looking operable; it also sorted by '_score', a relevance
           field that does not exist here. */
        function loadAll () {
            InvoiceHeader.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.invoiceHeaders = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }
    }
})();
